import React, { useEffect, useState } from "react";
import { parseURLParams } from "../helper";

const formStyles = {
  maxWidth: "800px",
  minWidth: "500px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const errorStyle = {
  color: "red",
};

export default function DetailForm() {
  const [whoYouAreError, setWhoYouAreError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [questionError, setQuestionError] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [stateError, setStateError] = useState(false);
  const [userid, setUserid] = useState("");
  const [userData, setUserData] = useState({});
  const [userDetails, setUserDetails] = useState({
    whoYouAre: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    state: "",
    pincode: "",
    question: "",
  });

  const submitHandler = (e) => {
    e.preventDefault();
    let numOfError = 0;
    if (!userDetails["whoYouAre"]) {
      numOfError += 1;
      setWhoYouAreError(true);
    } else {
      setWhoYouAreError(false);
    }
    if (!userDetails["name"]) {
      numOfError += 1;
      setNameError(true);
    } else {
      setNameError(false);
    }
    // if (!userDetails["email"]) {
    //   numOfError += 1;
    //   setEmailError(true);
    // } else {
    //   setEmailError(false);
    // }
    // if (!userDetails["phone"]) {
    //   numOfError += 1;
    //   setPhoneError(true);
    // } else {
    //   setPhoneError(false);
    // }
    // if (!userDetails["address"]) {
    //   numOfError += 1;
    //   setAddressError(true);
    // } else {
    //   setAddressError(false);
    // }
    // if (!userDetails["pincode"]) {
    //   numOfError += 1;
    //   setPincodeError(true);
    // } else {
    //   setPincodeError(false);
    // }
    if (!userDetails["question"]) {
      numOfError += 1;
      setQuestionError(true);
    } else {
      setQuestionError(false);
    }

    if (numOfError > 1) {
      return false;
    }

    console.log("submit clicked", userDetails);
  };

  const getUserDetails = async (userid) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3Addca9e4c-dc71-4302-941b-9eb58a8792fc4%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29127%7Cd%3A32"
    );

    var formdata = new FormData();
    formdata.append("action", "getuserdetail");
    formdata.append("userid", userid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/survey", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setUserData(result);
        let contact = result.user_contact_no;
        contact =
          contact.indexOf("+91") != "-1" ? contact.split("+91")[1] : contact;
        setUserDetails({
          ...userDetails,
          name: result.user_name_display,
          email: result.user_email,
          state: result["state_name"],
          phone: contact,
        });
      })
      .catch((error) => console.log("error", error));
  };

  const getStateList = () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3A10d42d42-3d3f-4263-adaa-208f869413557%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29127%7Cd%3A18"
    );

    var formdata = new FormData();
    formdata.append("action", "getstatelist");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/survey", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == 1) {
          setStateList(result.data);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    let par = parseURLParams(window.location.href);
    setUserid(par["userid"][0]);
    getStateList();
    getUserDetails(par["userid"][0]);
  }, []);

  return (
    <>
      <form style={formStyles} onSubmit={(e) => submitHandler(e)}>
        <div className="mb-3">
          <label htmlFor="whoyouare" className="form-label">
            Who you are ?
          </label>
          <select
            id="whoyouare"
            className="form-select"
            value={userDetails["whoYouAre"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, whoYouAre: e.target.value });
              e.target.value && setWhoYouAreError(false);
            }}
            onBlur={(e) =>
              e.target.value
                ? setWhoYouAreError(false)
                : setWhoYouAreError(true)
            }
          >
            <option value="">Select who you are</option>
            <option value="parent">Parent</option>
            <option value="teacher">Teacher</option>
            <option value="student">Student</option>
          </select>
          {whoYouAreError && (
            <p style={errorStyle}>Please select who you are</p>
          )}
        </div>
        <div className="mb-3">
          <label htmlFor="Name" className="form-label">
            Name
          </label>
          <input
            placeholder="e.g. John Doe"
            type="text"
            className="form-control"
            id="Name"
            value={userDetails["name"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, name: e.target.value });
              e.target.value && setNameError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setNameError(false) : setNameError(true)
            }
          />
          {nameError && <p style={errorStyle}>Please enter your name</p>}
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email Address
          </label>
          <input
            placeholder="e.g. johndoe@gmail.com"
            type="email"
            className="form-control"
            id="email"
            value={userDetails["email"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, email: e.target.value });
              e.target.value && setEmailError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setEmailError(false) : setEmailError(true)
            }
          />
          {emailError && (
            <p style={errorStyle}>Please enter your email address</p>
          )}
        </div>
        <div className="mb-3">
          <label htmlFor="phone" className="form-label">
            Phone
          </label>
          <input
            placeholder="Enter phone number"
            type="number"
            className="form-control"
            id="phone"
            defaultValue={userDetails["phone"].trim()}
            onChange={(e) => {
              setUserDetails({ ...userDetails, phone: e.target.value });
              e.target.value && setPhoneError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setPhoneError(false) : setPhoneError(true)
            }
          />
          {phoneError && <p style={errorStyle}>Please enter your phone</p>}
        </div>
        <div className="mb-3">
          <label htmlFor="address" className="form-label">
            Address
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your address"
            id="address"
            value={userDetails["address"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, address: e.target.value });
              e.target.value && setAddressError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setAddressError(false) : setAddressError(true)
            }
          />
          {addressError && <p style={errorStyle}>Please enter your address</p>}
        </div>
        <div className="mb-3">
          <label htmlFor="state" className="form-label">
            State
          </label>
          <select
            id="whoyouare"
            className="form-select"
            value={userDetails["state"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, state: e.target.value });
              e.target.value && setStateError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setStateError(false) : setStateError(true)
            }
          >
            <option value="">Select state</option>
            {stateList &&
              stateList.length > 0 &&
              stateList.map((state) => {
                return (
                  <option key={state["statename"]} value={state["statename"]}>
                    {state["statename"]}
                  </option>
                );
              })}
          </select>
          {stateError && <p style={errorStyle}>Please enter your state</p>}
        </div>
        <div className="mb-3">
          <label htmlFor="pincode" className="form-label">
            Pin Code
          </label>
          <input
            placeholder="Enter your pincode"
            type="number"
            className="form-control"
            id="pincode"
            value={userDetails["pincode"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, pincode: e.target.value });
              e.target.value && setPincodeError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setPincodeError(false) : setPincodeError(true)
            }
          />
          {pincodeError && <p style={errorStyle}>Please enter your pincode</p>}
        </div>
        <div className="mb-3">
          <label htmlFor="question" className="form-label">
            Question to PM
          </label>
          <input
            placeholder="Enter your question to PM"
            type="text"
            className="form-control"
            id="question"
            value={userDetails["question"]}
            onChange={(e) => {
              setUserDetails({ ...userDetails, question: e.target.value });
              e.target.value && setQuestionError(false);
            }}
            onBlur={(e) =>
              e.target.value ? setQuestionError(false) : setQuestionError(true)
            }
          />
          {questionError && (
            <p style={errorStyle}>Please enter your question to PM</p>
          )}
        </div>

        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </form>
    </>
  );
}
